const CHANGE_THEME = 'CHANGE_THEME';
const ADD_TODO = 'ADD_TODO';
const DO_LOGIN = 'DO_LOGIN';
const DO_LOGOUT = 'DO_LOGOUT';
const GET_USER_INFO = 'GET_USER_INFO';
const DO_PASSWORD_RESET = 'DO_PASSWORD_RESET';
const SEND_AUTHENTICATION_CODE = 'SEND_AUTHENTICATION_CODE';
const DO_PASSWORD_CHANGE = 'DO_PASSWORD_CHANGE';
// メニュー項目
const MENU_ITEMS = 'MENU_ITEMS';
const EXPANDED_MENU_ITEMS = 'EXPANDED_MENU_ITEMS';

export default {
  CHANGE_THEME,
  ADD_TODO,
  DO_LOGIN,
  DO_LOGOUT,
  GET_USER_INFO,
  DO_PASSWORD_RESET,
  SEND_AUTHENTICATION_CODE,
  DO_PASSWORD_CHANGE,
  MENU_ITEMS,
  EXPANDED_MENU_ITEMS,
};
